function MissingAuthPage() {
  return (
    <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignContent: 'center' }}>
      TODO: MISSING AUTH
    </div>
  )
}

export default MissingAuthPage